import { useEffect, useRef, useState } from 'react';
import L, { Map as LeafletMap, Marker } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { addBasemap, MAP_TILE_URL, MAP_TILE_OPTIONS } from '@/config/mapTiles';

delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

interface RideDriverMapProps {
  className?: string;
}

const RideDriverMap = ({ className = '' }: RideDriverMapProps) => {
  const mapRef = useRef<HTMLDivElement>(null);
  const mapInstanceRef = useRef<LeafletMap | null>(null);
  const [userLocation, setUserLocation] = useState<{ lat: number; lng: number } | null>(null);
  const defaultLocation = { lat: 13.4549, lng: -16.5790 };

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    const loc = userLocation || defaultLocation;
    const map = new LeafletMap(mapRef.current, {
      center: [loc.lat, loc.lng],
      zoom: 14,
      zoomControl: false,
    });

    addBasemap(map);

    mapInstanceRef.current = map;

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = { lat: position.coords.latitude, lng: position.coords.longitude };
          setUserLocation(location);
          map.setView([location.lat, location.lng], 15);

          const driverIcon = L.divIcon({
            html: '<div style="width:18px;height:18px;background:#1a1a2e;border-radius:50%;border:3px solid white;box-shadow:0 2px 8px rgba(0,0,0,0.4);"></div>',
            iconSize: [24, 24],
            className: 'custom-div-icon'
          });
          new Marker([location.lat, location.lng], { icon: driverIcon }).addTo(map);
        },
        () => console.log('Location denied')
      );
    }

    return () => {
      mapInstanceRef.current?.remove();
      mapInstanceRef.current = null;
    };
  }, []);

  return <div ref={mapRef} className={`w-full h-full ${className}`} />;
};

export default RideDriverMap;
